import {
  getCosToken,
  putObjectWithCosToken,
  type PutObjectWithCosTokenResult,
} from "./cos-token";

/** 素材上传结果 */
export type CosUploadMaterialFileResult = PutObjectWithCosTokenResult;

export interface CosUploadMaterialFileOptions {
  onProgress?: (progress: number) => void;
  signal?: AbortSignal;
}

/**
 * 素材场景：使用临时密钥将素材直传 COS（materia 场景）
 */
export const cosUploadMaterialFile = async (
  file: File,
  options?: CosUploadMaterialFileOptions
): Promise<CosUploadMaterialFileResult> => {
  const token = await getCosToken({ scene: "material", signal: options?.signal });
  return putObjectWithCosToken(token, {
    file,
    onProgress: options?.onProgress,
    signal: options?.signal,
  });
};
